/**
 * @generated SignedSource<<2102a3860a9bd86c10c1154e82c43a1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MenuItemType = "ARTICLES" | "EXTERNAL" | "PACKAGES" | "PAGE";
import { FragmentRefs } from "relay-runtime";
export type MenuItemsEditForm_menuItem$data = {
  readonly icon: string | null;
  readonly id: string;
  readonly name: string;
  readonly type: MenuItemType | null;
  readonly url: string | null;
  readonly " $fragmentType": "MenuItemsEditForm_menuItem";
};
export type MenuItemsEditForm_menuItem$key = {
  readonly " $data"?: MenuItemsEditForm_menuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"MenuItemsEditForm_menuItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MenuItemsEditForm_menuItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "MenuItem",
  "abstractKey": null
};

(node as any).hash = "21f892dbb3cf559e92654f3015f59278";

export default node;
